const appTheme = {
  light: {
  backgroundColor: '#f2f3f7',
  color: '#1b262c'
  },
  dark: {
    backgroundColor: '#121212',
    color: '#f2f3f7',
  }
}

export default appTheme;
